import Model from "../Model";

class Companytocomercialmessage extends Model{

    buildUrl () {
        return ['/internalmessage/sendallzone'];
    }

    all(config = {}) {
        return this.request({ method: 'POST', action: 'all', ...config });
    }

    create(form) {
        return this.request({
            action: 'store',
            method: 'POST',
            data: form
        });
    }
}


export default new Companytocomercialmessage;